import React, { Component } from 'react'
import '../css/dashboard.css'
import CountUp from 'react-countup'
import Slide1 from '../images/slide-1.jpg'
import Slide2 from '../images/slide-2.jpg'
import Slide3 from '../images/slide-3.jpg'


export default class Dashboard extends Component {
  render() {
    return (
      <div className="container p-3">
        <div className='row'>
          <div className="col-md-3">
            <div className="colo-box-b">
              <h6>Counter {this.props.name4}</h6>
              <CountUp
                className="account-balance"
                start={0}
                end={160527.0127}
                duration={2.75}
                useEasing={true}
                useGrouping={true}
                separator=" "
                decimals={3}
                decimal=","
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="colo-box-r">
              <h6>Counter {this.props.name1}</h6>
              <CountUp
                className="account-balance"
                start={0}
                end={160527.0127}
                duration={2.75}
                useEasing={true}
                useGrouping={true}
                separator=" "
                decimals={3}
                decimal=","
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="colo-box-y">
              <h6>Counter {this.props.name2}</h6>
              <CountUp
                className="account-balance"
                start={0}
                end={160527.0127}
                duration={2.75}
                useEasing={true}
                useGrouping={true}
                separator=" "
                decimals={3}
                decimal=","
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="colo-box-g">
              <h6>Counter {this.props.name3}</h6>
              <CountUp
                className="account-balance"
                start={0}
                end={160527.0127}
                duration={2.75}
                useEasing={true}
                useGrouping={true}
                separator=" "
                decimals={3}
                decimal=","
              />
            </div>
          </div>
          <div className="col-6 mt-2">
            <div id="carouselExampleControls" className="carousel slide" data-ride="carousel">
              <div className="carousel-inner">
                <div className="carousel-item active">
                  <img className="d-block w-100" src={Slide1} alt="First slide"></img>
                </div>
                <div className="carousel-item">
                  <img className="d-block w-100" src={Slide2} alt="Second slide"></img>
                </div>
                <div className="carousel-item">
                  <img className="d-block w-100" src={Slide3} alt="Third slide"></img>
                </div>
              </div>
              <a className="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="sr-only">Previous</span>
              </a>
              <a className="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="sr-only">Next</span>
              </a>
            </div>
          </div>
          <div className="col-6 mt-2">
            kjs
          </div>
        </div>
      </div>
    )
  }
}
